// removed by extract-text-webpack-plugin
module.exports = {"icon-container":"QuestionOptionsTable__icon-container___2SQ0g","lock-icon":"QuestionOptionsTable__lock-icon___1Z-0w"};